// extracted by mini-css-extract-plugin
export default {"header_text":"roadsRecorderHistory_header_text__6sxai"};